import { Card, Col, FormCheck, FormLabel, FormSelect, OverlayTrigger, Popover, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button } from '../common/Button.tsx'
import { closePopover, localized } from '../common/utils'
import { dashboardKey, emptyCard } from './common'

const sizes = {
	sm: { width: 'calc(25% - 2rem)' },
	md: { width: 'calc(37% - 2rem)' },
	lg: { width: 'calc(50% - 2rem)' },
	xl: { width: 'calc(100% - 2rem)' },
}

export function DashboardCard({ data, setCards, cardOptions, availableCards, localStorageKey }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const store = (value) => localStorage.setItem(localStorageKey || dashboardKey, JSON.stringify(value))

	const changeProperty = (key, value) =>
		setCards((cards) => {
			const newCards = cards.map((card, idx) => (idx === data.idx ? { ...card, [key]: value } : card))
			store(newCards)
			return newCards
		})

	const changeCard = (e) => {
		if (e.target.selectedOptions[0].className === 'premium') {
			dispatch(localized.premiumAlert)
		} else {
			changeProperty('name', e.target.value)
		}
	}
	const changeSize = (e) => changeProperty('size', e.target.value)

	const remove = () =>
		setCards((cards) => {
			closePopover()
			if (cards.length > 1) {
				const newCards = cards.filter((_card, idx) => idx !== data.idx)
				store(newCards)
				return newCards
			} else return cards
		})

	const insert = () =>
		setCards((cards) => {
			closePopover()
			const newCards = [...cards]
			newCards.splice(data.idx + 1, 0, emptyCard())
			store(newCards)
			return newCards
		})

	const popover = (
		<Popover className="text-center">
			<FormSelect size="sm" value={data.name} onChange={changeCard}>
				{cardOptions}
			</FormSelect>
			<Popover.Body>
				<Row>
					<Col>
						<FormLabel>
							{t('Small', 'Pieni')}
							<FormCheck type="radio" name="size" value="sm" checked={data.size === 'sm'} onChange={changeSize} />
						</FormLabel>
					</Col>
					<Col>
						<FormLabel>
							{t('Medium', 'Keskikoko')}
							<FormCheck type="radio" name="size" value="md" checked={data.size === 'md'} onChange={changeSize} />
						</FormLabel>
					</Col>
					<Col>
						<FormLabel>
							{t('Large', 'Suuri')}
							<FormCheck type="radio" name="size" value="lg" checked={data.size === 'lg'} onChange={changeSize} />
						</FormLabel>
					</Col>
					<Col>
						<FormLabel>
							XL
							<FormCheck type="radio" name="size" value="xl" checked={data.size === 'xl'} onChange={changeSize} />
						</FormLabel>
					</Col>
				</Row>
				<Row>
					<Button as={Col} className="mx-1" size="sm" variant="outline-danger" onClick={remove}>
						{t('Remove', 'Poista')}
					</Button>
					<Button as={Col} className="mx-1" size="sm" variant="outline-primary" onClick={insert}>
						{t('InsertNew', 'Lisää uusi')}
					</Button>
				</Row>
			</Popover.Body>
		</Popover>
	)

	return (
		<Card className="shadow2 m-3" style={sizes[data.size]} tabIndex={data.idx}>
			<OverlayTrigger trigger="click" placement="auto" overlay={popover} rootClose>
				<Button key={1} size="sm" className="ms-auto fw-bold mt-1 z-3" variant="light">
					⋮
				</Button>
			</OverlayTrigger>
			<Card.Body className="mx-auto w-100 mt-n6 overflow-auto">
				{availableCards[data.name] ? availableCards[data.name](data, changeProperty) : 'Error'}
			</Card.Body>
		</Card>
	)
}
